import React from 'react'

const ReceiveReimbursement = () => {
    return (
        <>
            <svg
                xmlns="http://www.w3.org/2000/svg"
                version="1.1"
                xmlnsXlink="http://www.w3.org/1999/xlink"
                width={80}
                height={80}
                x={0}
                y={0}
                viewBox="0 0 511.001 511.001"
                style={{ enableBackground: "new 0 0 512 512" }}
                xmlSpace="preserve"
                className=""
            >
                <g>
                    <circle
                        cx="319.501"
                        cy="143.501"
                        r={136}
                        fill="#f39842"
                        opacity={1}
                        data-original="#f39842"
                        className=""
                    />
                    <circle
                        cx="319.501"
                        cy="143.501"
                        r={104}
                        fill="#f4ed8e"
                        opacity={1}
                        data-original="#f4ed8e"
                    />
                    <path
                        fill="#ede243"
                        d="M351.501 223.501c-57.438 0-104-46.563-104-104 0-26.812 10.148-51.252 26.811-69.694-34.803 16.816-58.811 52.451-58.811 93.694 0 57.438 46.562 104 104 104 30.626 0 58.157-13.24 77.189-34.306-13.665 6.603-28.994 10.306-45.189 10.306z"
                        opacity={1}
                        data-original="#ede243"
                    />
                    <path
                        fill="#f39842"
                        d="m239.501 415.501 112-8s32-23.522 56-24 40 23.614 40 23.614l-80 48.386-128 8"
                        opacity={1}
                        data-original="#f39842"
                        className=""
                    />
                    <path
                        fill="#f6b171"
                        d="M471.501 383.506c-24 .478-72 39.989-72 39.989l-96 16.005-120-72h54.862c88 0 72-64 72-64H159.501l-152 24v128h88l208 48 120-32 80-56.381c0 .001-8-32.091-32-31.613z"
                        opacity={1}
                        data-original="#f6b171"
                        className=""
                    />
                    <path
                        fill="#f6b171"
                        d="m7.501 327.501 152-24h150.862s16 64-72 64H7.501v-40z"
                        opacity={1}
                        data-original="#f6b171"
                        className=""
                    />
                    <path
                        fill="#f39842"
                        d="M310.028 303.501c-4.349 18.163-20.26 40-71.665 40H135.501v24h102.862l72-64zM423.501 447.501l-120 32-208-48h-88v24h88l208 48 120-32 80-56.381s-2.376-9.496-8.4-18.08z"
                        opacity={1}
                        data-original="#f39842"
                        className=""
                    />
                    <path
                        d="M319.501 287.001c79.126 0 143.5-64.374 143.5-143.5S398.627.001 319.501.001s-143.5 64.374-143.5 143.5 64.374 143.5 143.5 143.5zm0-272c70.855 0 128.5 57.645 128.5 128.5s-57.645 128.5-128.5 128.5-128.5-57.645-128.5-128.5 57.645-128.5 128.5-128.5z"
                        fill="#000000"
                        opacity={1}
                        data-original="#000000"
                        className=""
                    />
                    <path
                        d="M319.501 255.001c61.481 0 111.5-50.019 111.5-111.5s-50.019-111.5-111.5-111.5-111.5 50.019-111.5 111.5 50.019 111.5 111.5 111.5zm0-208c53.21 0 96.5 43.29 96.5 96.5s-43.29 96.5-96.5 96.5-96.5-43.29-96.5-96.5 43.29-96.5 96.5-96.5z"
                        fill="#000000"
                        opacity={1}
                        data-original="#000000"
                        className=""
                    />
                    <path
                        d="M303.501 160.001h-32c-3.498 0-6.616 2.534-7.331 5.953-.692 3.308.966 6.726 3.977 8.255l96 48c3.906 1.956 8.76.062 10.344-3.992 1.392-3.56-.221-7.716-3.636-9.424l-67.584-33.792h.23c23.639 0 43.295-17.36 46.902-40h17.098c4.142 0 7.5-3.357 7.5-7.5s-3.358-7.5-7.5-7.5h-17.098c-1.528-9.589-5.938-18.224-12.309-25H367.5c4.142 0 7.5-3.357 7.5-7.5s-3.358-7.5-7.5-7.5h-96c-4.142 0-7.5 3.357-7.5 7.5s3.358 7.5 7.5 7.5h32c15.339 0 28.221 10.685 31.617 25H271.5c-4.142 0-7.5 3.357-7.5 7.5s3.358 7.5 7.5 7.5h63.617c-3.395 14.315-16.277 25-31.616 25zM7.492 335.002c.392 0 .789-.03 1.188-.094l150.277-23.907h68.252c4.142 0 7.5-3.357 7.5-7.5s-3.358-7.5-7.5-7.5h-68.845c-.395 0-.789.031-1.178.093l-150.862 24a7.501 7.501 0 0 0 1.168 14.908z"
                        fill="#000000"
                        opacity={1}
                        data-original="#000000"
                        className=""
                    />
                    <path
                        d="M510.778 413.305c-.383-1.534-9.633-37.306-38.715-37.306-.234 0-.475.003-.711.007-9.064.181-20.559 4.842-31.887 11-6.438-4.908-17.647-11.303-32.113-11.004-22.912.456-51.036 18.975-58.466 24.154l-83.672 5.533a7.469 7.469 0 0 0-2.477.605l-52.23-31.338c8.362.028 17.609.044 27.858.044 32.799 0 56.108-8.554 69.279-25.423 16.453-21.072 10.268-46.811 9.997-47.896a7.499 7.499 0 0 0-7.276-5.681h-48c-4.142 0-7.5 3.357-7.5 7.5s3.358 7.5 7.5 7.5h41.522c.522 6.952-.04 19.065-8.066 29.347C285.638 353.388 266.307 360 238.364 360c-85.942 0-101.66-1.104-102.272-1.15-4.113-.326-7.741 2.757-8.067 6.886a7.5 7.5 0 0 0 6.886 8.067c.447.035 8.691.645 46.15.98l118.582 71.149a7.505 7.505 0 0 0 5.092.966l96-16.005a7.51 7.51 0 0 0 3.532-1.606c12.799-10.529 49.855-37.934 67.383-38.283l.354-.003c12.72 0 19.746 13.705 22.634 21.189l-74.364 52.409-116.904 31.174-206.183-47.58a7.48 7.48 0 0 0-1.687-.192h-88c-4.142 0-7.5 3.357-7.5 7.5s3.358 7.5 7.5 7.5h87.146l207.167 47.808a7.507 7.507 0 0 0 3.62-.061l120-32a7.528 7.528 0 0 0 2.388-1.116l80-56.381a7.5 7.5 0 0 0 2.957-7.946zm-114.47 3.12-91.316 15.225-20.352-12.211 67.356-4.454a7.515 7.515 0 0 0 3.944-1.438c.302-.221 30.397-22.121 51.71-22.547 6.983-.141 13.007 2.102 17.486 4.558-13.161 8.477-24.383 17.28-28.828 20.867z"
                        fill="#000000"
                        opacity={1}
                        data-original="#000000"
                        className=""
                    />
                </g>
            </svg>

        </>
    )
}

export default ReceiveReimbursement